import { toastMessagesReducerKey } from './ToastMessagesConstants';
import { createSelector } from 'reselect';

export function toastMessages (state) {
  return state.get(toastMessagesReducerKey);
}

export function toastMessagesRightTop (state) {
  return toastMessages(state).get('messagesRightTop');
}

export const toastMessagesWhichIsNotDeliting = createSelector(
  [toastMessagesRightTop],
  (messages) => {
    return messages.filter((message) => {
      const {removingInProgress} = message;

      return !removingInProgress;
    });
  }
);

function findPoorNetworkConnectionMessage(messages) {
  return messages.find((message) => {
    const {poorNetworkConnection} = message;

    return poorNetworkConnection;
  });
}

export const poorNetworkConnectionMessage = createSelector(
  [toastMessagesRightTop],
  findPoorNetworkConnectionMessage
);

export const poorNetworkConnectionMessageActive = createSelector(
  [toastMessagesWhichIsNotDeliting],
  findPoorNetworkConnectionMessage
);
